"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactFormTabUI = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../dsl/front");
/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let ContactFormTabUI = class ContactFormTabUI extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        /**
         * Message to display
         */
        this.message = '';
        /**
         * Data entered by the User.
         */
        this.formData = {
            name: null,
            email: null,
            theme: null,
            message: null,
            agreement: null
        };
    }
    get agreementText() {
        return this.welcomeFormConfig.agreement || this.$t('components.WelcomeForm.agreement');
    }
    submitForm() {
        this.onSubmit(this.formData).then(() => {
            this.message = String(this.$t('modules.contact.onSuccess'));
        }).catch(() => {
            this.message = String(this.$t('modules.contact.onError'));
        }).finally(() => {
            this.formData = {
                name: null,
                email: null,
                theme: null,
                message: null,
                agreement: null
            };
        });
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Function, required: true }),
    __metadata("design:type", Function)
], ContactFormTabUI.prototype, "onSubmit", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], ContactFormTabUI.prototype, "welcomeFormConfig", void 0);
ContactFormTabUI = __decorate([
    vue_property_decorator_1.Component({
        name: 'ContactFormTabUI',
        components: {
            BootstrapInput: front_1.BootstrapInput,
            BootstrapButton: front_1.BootstrapButton,
            BootstrapTextArea: front_1.BootstrapTextArea,
            BootstrapCheck: front_1.BootstrapCheck
        },
        template: `
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <form class="row justify-content-center" @submit.prevent="submitForm">
            <div class="col-12 col-sm-9 col-md-10 col-lg-5">
              <!-- Name -->
              <BootstrapInput name="name"
                              autocomplete="name" :required="true" :model.sync="formData.name"
                              :label="$t('_.name-and-surname')" class="mb-3" />

              <!-- E-mail address -->
              <BootstrapInput type="email" name="email" :model.sync="formData.email"
                              autocomplete="email" :required="true"
                              :label="$t('_.email-address')" class="mb-3" />

              <!-- Theme -->
              <BootstrapInput name="subject" :model.sync="formData.theme" :required="true"
                              :label="$t('_.theme')" class="mb-3" />

              <!-- Message -->
              <BootstrapTextArea name="organization" :model.sync="formData.message"
                              autocomplete="organization" :required="true"
                              :label="$t('_.message')" class="mb-3" />

              <div class="text-start">
                <BootstrapCheck name="agreement" :model.sync="formData.agreement"
                                :options="[{
                                label: agreementText,
                                value: true
                              }]" :multiple="true" :required="true" class="mb-5" />
              </div>

              <p v-if="message !== ''" class="text-center">{{message}}</p>

              <!-- "Submit" button -->
              <div class="d-flex justify-content-center">
                <BootstrapButton type="submit" class="contact__form__submit">
                  {{ $t('modules.contact.tabs.contactForm.submit') }}
                </BootstrapButton>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  `
    })
], ContactFormTabUI);
exports.ContactFormTabUI = ContactFormTabUI;
//# sourceMappingURL=ContactForm.js.map